module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "OldFlames_epub-1.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "CT-new-page para-style-override-1"
  }, [_c('span', {
    staticClass: "Section-Symbol char-style-override-1"
  }, [_vm._v("b")]), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("y the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("1963")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Black Out")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc8c8902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OldFlames_epub1.vue
// module id = 57
// module chunks = 0